<template>
  <div>
    <img
      :src="`${template.WebPushProps.BadgeImageURL}?${Date.now()}`"
      alt="banner"
      class="web-push-preview-body__banner"
    />

    <div class="web-push-preview-body-main">
      <div
        v-if="template.WebPushProps.IconURL"
        class="web-push-preview-body-main__icon"
        :style="{
          backgroundImage: `url(${template.WebPushProps.IconURL})`,
        }"
      ></div>

      <div class="web-push-preview-body-main-data">
        <div class="web-push-preview-body-main-data__close">
          <span class="web-push-preview-body-main-data__close-img">
            &#10005;
          </span>
        </div>
        <div class="web-push-preview-body-main-data__title">
          {{  template.Title || template.Subject }}
        </div>
        <div class="web-push-preview-body-main-data__text">
          {{ template.Template }}
        </div>
        <span class="web-push-preview-body-main-data__link">
          https://test-url.ru
        </span>
      </div>
    </div>

    <div class="web-push-preview-body-buttons">
      <div
        v-for="(button, i) in template.WebPushProps.Buttons"
        class="web-push-preview-body__button"
        :key="`demoButton_${i}`"
        @click="onOpenUrl(button.URL)"
    >
        <img
          :src="button.ButtonIconURL"
          alt=""
          class="web-push-preview-body__button-icon"
        />
        <span> {{ button.ButtonText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "web-push-preview--windows10",

  props: {
    template: {
      type: Object
    }
  },

  methods: {
    onOpenUrl(url) {
      window.open(url, "_blank");
    }
  }
}
</script>

<style lang="scss">
.web-push-preview {
  .web-push-preview-body {
    border-radius: 10px;
    &__banner {
      width: 100%;
      height: auto;
      max-height: 180px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }

    &-main {
      height: auto;
      display: flex;
      overflow: hidden;
      width: 100%;

      &__icon {
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        width: 150px;
      }

      &-data {
        padding: 10px 10px 10px 19px;
        width: 100%;

        &__close {
          margin-bottom: 4px;
          line-height: 1;
        }

        &__close-img {
          display: block;
          font-size: 14px;
          font-weight: 600;
          text-align: right;
          cursor: pointer;
        }

        &__title {
          line-height: 1;
          font-weight: bold;
          margin-bottom: 8px;
        }

        &__text {
          height: 45px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          color: #474747;
        }

        &__link {
          font-size: 10px;
          color: #989898;
          align-self: flex-end;
        }
      }
    }

    &__button {
      background: $color_white;
      border-top: 1px solid #d7d7d7;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
      text-align: center;
      color: #454545;
      padding: 8px 0;
      cursor: pointer;
      line-height: 1;
    }

    &__button-icon {
      height: 15px;
      margin-left: auto;
      margin-right: 0;
      position: relative;
      top: 2px;
    }
  }
}
</style>
